export default "__VITE_ASSET__TNFaFeHw__"